
<template>
  <div>
    <div class="box">
      <Navigation :route="navigationRoute" class="mb-18"></Navigation>

      <div class="flex-btw" v-for="(item, index) in tableData.records" :key="index">
        <div class="title one-row" @click="handleDetail(item.id)">{{ item.title }}</div>
        <div class="time">{{ item.startTime.slice(0, -9) }}</div>
      </div>
      <!-- <div class="flex-btw">
        <div class="title one-row" @click="handleDetail">中共中央政治局召开会议 分析研究当前经济形势和经济工作 中共中央总书记习近平主持会议</div>
        <div class="time">2024-12-05</div>
      </div>
      <div class="flex-btw">
        <div class="title one-row" @click="handleDetail">中共中央政治局召开会议 分析研究当前经济形势和经济工作</div>
        <div class="time">2024-11-06</div>
      </div>
      <div class="flex-btw">
        <div class="title one-row" @click="handleDetail">习近平总书记为航天强国建设注入强劲动力</div>
        <div class="time">2024-10-10</div>
      </div>
      <div class="flex-btw">
        <div class="title one-row" @click="handleDetail">中央党的建设工作领导小组召开会议 研究部署深入贯彻中央八项规定精神学习教育工作 蔡奇主持并讲话 李希出席研究部署深入贯彻中央八项规定精神学习教育工作</div>
        <div class="time">2024-06-05</div>
      </div>
      <div class="flex-btw">
        <div class="title one-row" @click="handleDetail">中办印发《通知》在全党开展深入贯彻中央八项规定精神学习教育</div>
        <div class="time">2024-05-22</div>
      </div> -->

      <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
        :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { getNews } from '@/api/index';

export default {
  components: {
    Navigation
  },
  data() {
    return {
      navigationRoute: [
        { name: '首页' },
        { name: '通知公告列表' },
      ],
      query: {
        current: 1,
        size: 10
      },
      tableData: { //表格数据
        total: 0,
        records: []
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },
    getList() {
      // Mock data for demonstration
      getNews(this.query).then(res => {
        this.tableData.total = res.total
        this.tableData.records = res.records
      }).catch(err => {
        console.error(err)
      })

      // this.tableData.total = 100
      // this.tableData.records = Array.from({ length: 10 }, (_, i) => ({
      //   title: `Title ${i + 1}`,
      //   time: `2024-01-${i + 1}`
      // }))
    },
    handleDetail(id) {
      this.$router.push({ path: '/notice/detail?id=' + id })
    }
  },
}
</script>

<style lang="scss" scoped>
.box {
  background-color: #fff;
  padding: 24px 40px 40px 24px;
  font-weight: 400;
  font-size: 18px;
  color: #1A1A1A;
  line-height: 27px;

  .title {
    position: relative;
    width: 0;
    flex: 1;
    margin-right: 40px;
    margin-bottom: 20px;
    padding-left: 26px;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      left: 6px;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      background: red;
      border-radius: 50%;
    }
  }

  .time {
    font-weight: 400;
    color: #767676;
  }
}
</style>
